import { combineReducers } from "redux"

import authReducer from "../features/auth/authSlice"
import authListReducer from "../features/auth/authList"

const rootReducer = combineReducers({
  auth: authReducer,
  authList: authListReducer
})

export default rootReducer
